import './assets/RichText.css';const o = "RichText-module__root___BL9OM", t = "RichText-module__editor___HoTht", e = "RichText-module__toolbar___NoOK4", _ = "RichText-module__codeButton___M-9H-", n = "RichText-module__content___kYPjI", i = "RichText-module__link___9IL5-", l = "RichText-module__controlsGroup___uWj9G", c = "RichText-module__control___6Qq31", u = "RichText-module__heading___S-utG", a = "RichText-module__fontFamilyButton___PnDM1", r = "RichText-module__fontFamilyButtonLabel___hzGYv", d = "RichText-module__fontSizeButton___8EA6d", m = "RichText-module__fontSizeButtonLabel___43Oxf", s = "RichText-module__richColorPickerSwatch___3leHQ", h = "RichText-module__floatingImageToolbar___8fTqt", T = "RichText-module__resizeHandle___3uaGt", R = "RichText-module__imageWrapper___PnaX0", x = "RichText-module__image___M-CWf", f = "RichText-module__imageMenu___20F1-", g = "RichText-module__linkMenu___WSaG7", b = "RichText-module__tableMenu___s3URO", B = "RichText-module__lineHeightButton___Xd5oi", p = "RichText-module__fontHeadingDropdown___BBIFj", k = "RichText-module__buttonTooltip___cqwRa", M = "RichText-module__formatControls___X0jh3", C = "RichText-module__desktopControls___fRhKA", H = "RichText-module__mobileControls___-VvVM", S = "RichText-module__codeEditor___6kop6", z = {
  root: o,
  editor: t,
  toolbar: e,
  codeButton: _,
  content: n,
  link: i,
  controlsGroup: l,
  control: c,
  heading: u,
  fontFamilyButton: a,
  fontFamilyButtonLabel: r,
  fontSizeButton: d,
  fontSizeButtonLabel: m,
  richColorPickerSwatch: s,
  floatingImageToolbar: h,
  resizeHandle: T,
  imageWrapper: R,
  image: x,
  imageMenu: f,
  linkMenu: g,
  tableMenu: b,
  lineHeightButton: B,
  fontHeadingDropdown: p,
  buttonTooltip: k,
  formatControls: M,
  desktopControls: C,
  mobileControls: H,
  codeEditor: S
};
export {
  z as c
};
